module.exports = __webpack_public_path__ + "img/bg_image_5.a962727e.png";